import { ActionColumn, RowForm } from "@airborne/react-admin";
import * as React from "react";
import { TextInput, BooleanInput, required, TextField } from "react-admin";

const CustomerUserEditForm = props => {
  return (
    <RowForm {...props} mutationMode={"pessimistic"}>
      <TextField source="registerId" label="Register Id" />
      <TextInput source="ownerCode" label="Owner Code" variant="outlined" validate={required()} />
      <BooleanInput source="isEditable" label="Is Editable" variant="outlined" />
      <ActionColumn />
    </RowForm>
  );
};

export default CustomerUserEditForm;
